import { CoverageMineSubsidenceScheduledItemInput as OtherStructure } from "@covertree/new-business-graphql";

enum ModalTitle {
  Initial = "Mine Subsidence - Other Structures - Scheduled",
  LimitAndDescription = "What is the other structure limit and description?",
  OtherStructureAdded = "Other Structure Added",
  OtherStructureRemoved = "Other Structure Removed",
}

type OtherStructureWithPrice = OtherStructure & {
  id?: string;
  price?: number;
};

export { ModalTitle, type OtherStructure, type OtherStructureWithPrice };
